export default {
  methods: {
    isValidNumber(number) {
      return !Number.isNaN(number) && number !== null && number !== undefined;
    },
    toLocaleString(number, withDecimals = false) {
      if (!this.isValidNumber(number)) return '-';
      return withDecimals ? number.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
        : number.toLocaleString();
    },
    convertNumberToString(number) {
      return number && number < 10 ? `0${number}` : number;
    },
  },
};
